
    document.addEventListener("DOMContentLoaded", function () {
    const grid = document.querySelector(".history-grid");
    const colLeft = grid.querySelector(".col-left");
    const colRight = grid.querySelector(".col-right");

    // Store original items
    const originalLeftItems = Array.from(colLeft.children);
    const originalRightItems = Array.from(colRight.children);

    function applyMobileLayout() {
      const merged = [];
    const maxLength = Math.max(originalLeftItems.length, originalRightItems.length);
    for (let i = 0; i < maxLength; i++) {
        if (originalLeftItems[i]) merged.push(originalLeftItems[i]);
    if (originalRightItems[i]) merged.push(originalRightItems[i]);
      }

    // Clear grid and append merged items
    grid.innerHTML = "";
      merged.forEach(item => grid.appendChild(item));
    }

    function applyDesktopLayout() {
        // Clear grid
        grid.innerHTML = "";

    // Recreate columns
    const newLeft = document.createElement("div");
    newLeft.className = "col-left";
      originalLeftItems.forEach(item => newLeft.appendChild(item));

    const newRight = document.createElement("div");
    newRight.className = "col-right";
      originalRightItems.forEach(item => newRight.appendChild(item));

    grid.appendChild(newLeft);
    grid.appendChild(newRight);
    }

    function handleResize() {
      if (window.innerWidth < 768) {
        applyMobileLayout();
      } else {
        applyDesktopLayout();
      }
    }

    // Initial layout
    handleResize();

    // Responsive on resize
    window.addEventListener("resize", handleResize);
  });
